import { useContext } from 'react';
import { useMutation } from 'react-query';
import { ApiContext, EntitiesContext } from '../App';
import * as ActionTypes from '../constants/action-types';

const options = {}
const resource = 'addresses';

export const useUpdateAddress = () => {
  const api = useContext(ApiContext);
  const entities = useContext(EntitiesContext);

  return useMutation(address => api.put(`/${resource}/${address.id}`, address), {
    onSuccess: data => entities.dispatch({
      type: ActionTypes.RECEIVE_ENTITY,
      payload: data.data
    })
  });
}
